import React from 'react'
import { useParams } from 'react-router-dom'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { InviteCollaboratorsLink } from '@sputnik/components/InviteCollaborators'

import styles from './styles.module.scss'

const InviteCollaborator = () => {
  const { appId } = useParams()
  const [getClassName] = useNameFormatter('InviteCollaborator')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('question')]}>
        <FormattedMessage
          defaultMessage='Need help filling out the application?'
          id='sputnik.InviteCollaborator__3CB/+g'
        />
      </div>
      <div className={styles[getClassName('action')]}>
        <InviteCollaboratorsLink appId={appId ?? ''} />
      </div>
    </div>
  )
}

export default InviteCollaborator
